var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1041,
    height: 157,
    viewBox: "0 0 1041 157",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -24.077,
    y: -24.0516,
    width: 1089.22,
    height: 205.3
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12.35px)",
      clipPath: "url(#bgblur_0_1986_10085_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 24.7,
    d: "M0.623047 19.6484C0.623047 9.15503 9.12964 0.648438 19.623 0.648438H1021.44C1031.94 0.648438 1040.44 9.15503 1040.44 19.6484V137.548C1040.44 148.042 1031.94 156.548 1021.44 156.548H19.623C9.12962 156.548 0.623047 148.042 0.623047 137.548V19.6484Z",
    fill: "#D9D9D9",
    fillOpacity: 0.84
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1986_10085_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(24.077 24.0516)",
    d: "M0.623047 19.6484C0.623047 9.15503 9.12964 0.648438 19.623 0.648438H1021.44C1031.94 0.648438 1040.44 9.15503 1040.44 19.6484V137.548C1040.44 148.042 1031.94 156.548 1021.44 156.548H19.623C9.12962 156.548 0.623047 148.042 0.623047 137.548V19.6484Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur);
export default __webpack_public_path__ + "static/media/blur.c74231e3c92f2e2c0ceb6228172efd4d.svg";
export { ForwardRef as ReactComponent };